import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-poshvine-label-fab',
  templateUrl: './label-fab.component.html',
  styleUrls: ['./label-fab.component.scss'],
})

export class LabelFabComponent implements OnInit {
  @Input() public labelTitle: string = 'Shopping'
  @Input() public avatarPath: string = './../../../assets/svg/amazon-logo.svg';
  @Input() public isSvg: boolean = false;
  @Input() public isGeneric: boolean = false;
  @Input() public isLoading = false;
  constructor(
  ) {
  }

  ngOnInit(): void {
  }
}
